module.exports = __webpack_public_path__ + "img/attack_fireseed.26d9846f.png";